import React from 'react';

import { MDText } from 'i18n-react';

import { LoadingArrow } from 'Storybook/components/local/LoadingArrow/LoadingArrow';

import LocalTexts from '../../../Payments.text.json';

import styles from './FiguresBoxLoader.scss';

const LocalT = new MDText(LocalTexts.payments.figuresBox.loader);

interface FiguresBoxLoaderProps {
  label?: string;
}

const FiguresBoxLoader = ({ label = `${LocalT.translate('defaultCopy')}` }: FiguresBoxLoaderProps) => (
  <div className={styles.loaderWrapper}>
    <LoadingArrow showText size="large" text={label} />
  </div>
);

export { FiguresBoxLoader };
